import './App.css';
import React, { useEffect, useState } from "react";
import { Toaster } from 'react-hot-toast'
import { useAuthContext } from './hooks/agencyAuthHook';
import ProfileHook from './hooks/ProfileHook';
import { useSelector } from 'react-redux';

import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import MoonLoader from "react-spinners/MoonLoader";
import Signup from './components/authorized/Signup'
import Login from './components/authorized/Login'
import OTPVerification from './components/authorized/OTPVerification.jsx'

import ForgotPassword from './components/authorized/ForgotPassword'
import Configurations from './components/authorized/Configurations'
import Packages from './components/authorized/Packages'
import Dashboard from './components/authorized/Dashboard'
import Bookings from './components/authorized/Bookings'
import Vouchers from './components/authorized/Vouchers.jsx'
import Profile from './components/authorized/Profile'
import PriceCalculator from './components/authorized/PriceCalculator'
import BookingCalendar from './components/authorized/BookingCalendar'
import Parties from './components/authorized/Parties.jsx'
import VoucherSetting from './components/authorized/voucherSetting/VoucherSetting.jsx'

import Sidebar from './components/authorized/Sidebar'
import Navbar from './components/authorized/Navbar'

function App() {
  const { agency } = useAuthContext();
  const { getAgencyProfile } = ProfileHook();
    const profile = useSelector((state) => state.profile.profile);
  
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    if(agency){
      getAgencyProfile()

    }
    
    if (agency !== undefined ||!profile){
      setLoading(false);
    }
  }, [agency]);

  if (loading) {
    return <div className='mt-5 '>
      <MoonLoader color="#08A5DC" className='mt-5 mx-auto' />
    </div>
  }
  return (
    <div className="App">
      <BrowserRouter>
        {agency && <Navbar />}
        {agency && <Sidebar />}
        <Routes>
          <Route path="/" element={agency ? <Dashboard /> : <Login></Login>} />
          <Route path="/signup" element={!agency ? <Signup></Signup> : <Navigate to="/" />} />
          <Route path="/forgot_password" element={!agency ? <ForgotPassword></ForgotPassword> : <Navigate to="/" />} />
          <Route path="/setting/:type" element={(agency &&agency?.role?.trim().toLowerCase().includes('agency')) ? <Configurations></Configurations> : <Navigate to="/" />} />
          <Route path="/packages" element={agency ? <Packages></Packages> : <Navigate to="/" />} />
          <Route path="/bookings" element={agency ? <Bookings></Bookings> : <Navigate to="/" />} />
          <Route path="/vouchers" element={agency ? <Vouchers></Vouchers> : <Navigate to="/" />} />
          <Route path="/profile" element={(agency) ? <Profile></Profile> : <Navigate to="/" />} />
          <Route path="/price_calculator" element={(agency &&agency?.role?.trim().toLowerCase().includes('agency')) ? <PriceCalculator></PriceCalculator> : <Navigate to="/" />} />
          <Route path="/parties" element={(agency &&agency?.role?.trim().toLowerCase().includes('agency')) ? <Parties></Parties> : <Navigate to="/" />} />
          <Route path="/booking_calendar" element={agency ? <BookingCalendar></BookingCalendar> : <Navigate to="/" />} />
          <Route path="/voucher_settings" element={(agency &&agency?.role?.trim().toLowerCase().includes('agency')) ? <VoucherSetting/> : <Navigate to="/" />} />
          <Route path="/email_verification" element={<OTPVerification></OTPVerification>} />
          {/*<Route path="/parties" element={(agency &&agency?.role?.trim().toLowerCase().includes('agency')) ? <Parties></Parties>:<Navigate to="/" />} />*/}
        </Routes>
      </BrowserRouter>

      <Toaster
        position="top-center"
        reverseOrder={false}
      />
    </div>
  );
}

export default App;
